module.exports = __webpack_public_path__ + "static/img/coupon.6f8e57a9.png";